import { type JSONObject } from '@imago/api-client'
import { type DocBlock } from './_Doc.ts'
import { type EMRKindID, type EMRTypeID } from './_EMR.ts'
import { TokenStream } from './_parsing.ts'

export const SurgeryInterest_ID = 'imago.user-surgery-interest' as EMRTypeID & EMRKindID

export interface UserSurgeryInterestContent {
	procedures: Set<string>
	totalPrice: string
	when: string
}

export interface UserSurgeryInterestContentJSON extends JSONObject {
	procedures: string[]
	totalPrice: string
	when: string
}

export function deserializeUserSurgeryInterestContent(userSurgeryInterest: UserSurgeryInterestContentJSON): UserSurgeryInterestContent {
	return {
		...userSurgeryInterest,
		procedures: new Set(userSurgeryInterest.procedures),
	}
}

export function serializeUserSurgeryInterestContent(userSurgeryInterest: UserSurgeryInterestContent | undefined | null): UserSurgeryInterestContentJSON | undefined | null {
	return !userSurgeryInterest ? userSurgeryInterest : {
		...userSurgeryInterest,
		procedures: [...userSurgeryInterest.procedures],
	}
}

export function parseUserSurgeryInterest(md: DocBlock[]): UserSurgeryInterestContent {
	const ts = new TokenStream(md[Symbol.iterator]())

	ts.match("TITLE", "User surgery interest")
	const content = ts.consumePlainContent()

	const interest: UserSurgeryInterestContent = {
		procedures: new Set(),
		totalPrice: '',
		when: '',
	}

	for (const line of content.split('\n')) {
		if (!line) continue

		if (line.startsWith('- ')) {
			interest.procedures.add(line.substring(': '.length))
		} else {
			const sepPos = line.indexOf(': ')
			const key = line.substring(0, sepPos)
			const value = line.substring(sepPos + ': '.length)

			if (key === 'Total price') {
				interest.totalPrice = value
			} else if (key === 'When') {
				interest.when = value
			} else {
				console.warn(`Unknown profile key: ${key}`)
			}
		}
	}

	return interest
}

export function docifyUserSurgeryInterest(interest: UserSurgeryInterestContent): DocBlock[] {
	return [
		{ class: 'TITLE', text: "User surgery interest" },
		...[...interest.procedures].map(surg => ({ class: 'NORMAL_TEXT', text: `- ${surg}` } satisfies DocBlock)),
		{ class: 'NORMAL_TEXT', text: `Total price: ${interest.totalPrice}` },
		{ class: 'NORMAL_TEXT', text: `When: ${interest.when}` },
	]
}


